import React from 'react';
import { PerformanceData } from '../types';
import { Panel } from '../components/UIComponents';
import { bulletWarningsViewStyles } from '../styles';

interface BulletWarningsViewProps {
  request: PerformanceData;
  onBack: () => void;
  onClose: () => void;
}

export const BulletWarningsView: React.FC<BulletWarningsViewProps> = ({ request, onBack, onClose }) => {
  return (
    <Panel title={`Bullet Warnings - ${request.name}`} onBack={onBack} onClose={onClose} fullScreen>
      {request.bulletWarnings &&
        request.bulletWarnings.length > 0 &&
        request.bulletWarnings.map((warning, index) => (
          <div key={index} style={bulletWarningsViewStyles.warningContainer}>
            <h5 style={bulletWarningsViewStyles.warningTitle}>⚠ Bullet Warning Detected!</h5>
            <div style={bulletWarningsViewStyles.infoItem}>
              <strong>Model:</strong> {warning.base_class}
            </div>
            <div style={bulletWarningsViewStyles.infoItem}>
              <strong>Association(s):</strong> {warning.associations.join(', ')}
            </div>
            <div style={bulletWarningsViewStyles.infoItem}>
              <strong>Suggestions:</strong> {warning.notice}
            </div>
            <div>
              <strong>Caller:</strong>
              <pre style={bulletWarningsViewStyles.callerCode}>
                {warning.callers.map((caller, idx) => (
                  <React.Fragment key={idx}>
                    {caller}
                    {idx < warning.callers.length - 1 && <br />}
                  </React.Fragment>
                ))}
              </pre>
            </div>
          </div>
        ))}
    </Panel>
  );
};
